import type { MutationSettings } from '@customTypes/index';
import { useMutation } from '@tanstack/react-query';

import type { ArtistPostProfileAboutParams } from '@/shared/api/requests/artist/about/post/request';
import { artistPostProfileAbout } from '@/shared/api/requests/artist/about/post/request';

export const useArtistProfileAboutMutation = (
  settings?: MutationSettings<
    ArtistPostProfileAboutParams,
    typeof artistPostProfileAbout
  >
) =>
  useMutation({
    mutationKey: ['ArtistProfileAbout'],
    mutationFn: ({ params, config }) =>
      artistPostProfileAbout({
        params,
        config
      }),
    ...settings?.options
  });
